function withoutTrailingPeriod(value: string): string {
  return value.replace(/\.$/, '')
}

export function formatChartDayLabel(
  isoDate: string,
  locale: string
): { weekdayLine: string; dateLine: string } {
  const date = new Date(`${isoDate}T12:00:00`)
  const weekdayLine = withoutTrailingPeriod(
    date.toLocaleDateString(locale, { weekday: 'short' })
  )
  const dateLine = withoutTrailingPeriod(
    date.toLocaleDateString(locale, {
      day: 'numeric',
      month: 'short',
    })
  )
  return { weekdayLine, dateLine }
}

export function formatChartRange(labels: string[], locale: string): string {
  if (labels.length === 0) return ''

  const first = new Date(`${labels[0]}T12:00:00`)
  const last = new Date(`${labels[labels.length - 1]}T12:00:00`)
  const fullDateFormatter = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
  })
  const sameMonth =
    first.getMonth() === last.getMonth() &&
    first.getFullYear() === last.getFullYear()

  if (sameMonth) {
    const firstDay = first.toLocaleDateString(locale, { day: 'numeric' })
    const lastDay = last.toLocaleDateString(locale, { day: 'numeric' })
    const month = withoutTrailingPeriod(
      first.toLocaleDateString(locale, { month: 'short' })
    )
    const parts = fullDateFormatter.formatToParts(first)
    const monthComesFirst =
      parts.findIndex(part => part.type === 'month') <
      parts.findIndex(part => part.type === 'day')

    return monthComesFirst
      ? `${month} ${firstDay} - ${lastDay}`
      : `${firstDay} - ${lastDay} ${month}`
  }

  const firstLabel = withoutTrailingPeriod(fullDateFormatter.format(first))
  const lastLabel = withoutTrailingPeriod(fullDateFormatter.format(last))
  return `${firstLabel} - ${lastLabel}`
}
